import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";

function useNodesClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({
      getToken: () => session?.accessToken ?? null,
      onUnauthorized: logout,
    });
}

function useInvalidateNodes() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: queryKeys.resource("nodes") });
    // Drain ändert Agent-Assignments — Agents-Resource ebenfalls invalidieren.
    qc.invalidateQueries({ queryKey: queryKeys.resource("agents") });
  };
}

// #177: Node draine — alle assigned Agents werden unassigned.
export function useDrainNode(): UseMutationResult<{ drained: number }, Error, string> {
  const getClient = useNodesClient();
  const invalidate = useInvalidateNodes();
  return useMutation({
    mutationFn: (id) => getClient().post<{ drained: number }>(`/nodes/${id}/drain`, {}),
    onSuccess: invalidate,
  });
}

// #177: Endgueltiges Loeschen. Blockt mit 409 wenn noch Agents assigned.
export function useDeleteNode(): UseMutationResult<void, Error, string> {
  const getClient = useNodesClient();
  const invalidate = useInvalidateNodes();
  return useMutation({
    mutationFn: (id) => getClient().delete<void>(`/nodes/${id}`),
    onSuccess: invalidate,
  });
}
